import { render, staticRenderFns } from "./layoutUser.vue?vue&type=template&id=474fc864&scoped=true"
import script from "./layoutUser.vue?vue&type=script&lang=js"
export * from "./layoutUser.vue?vue&type=script&lang=js"
import style0 from "./layoutUser.vue?vue&type=style&index=0&id=474fc864&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fc864",
  null
  
)

export default component.exports